<template>
    <div class="placeholder w-full sm:w-auto">
        <div class="w-full sm:w-1/3 lg:w-64 mt-0 sm:mt-6 px-0 sm:px-2" class2="px-4">
            <div class="card card-product card-profile rounded shadow-none cursor-pointer">
                <div class="card-body py-2 px-3 text-left sm:text-center cursor-pointer border-0 flex items-center sm:block" style="border:0 !important;">
                    <div class="preview object-contain h-20 w-20 sm:h-32 sm:w-full" class2="card-img"></div>
                    <div class="heading ml-5 sm:ml-0 mt-0 sm:mt-4 mb-0 sm:mb-0 text-xl sm:h-16 font-bold overflow-hidden text-truncate2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
.card-profile {
    border-width: 1px;
}

.card-product {
    border: 1px solid rgba(72, 94, 144, 0.2);
    // border-width: 0;

    .card-body {
        border-left-width: 0;
        border-right-width: 0;
    }
}

.placeholder {
    @apply relative flex flex-col items-center;
}

.placeholder .preview {
    @apply text-center flex flex-col items-center;
    margin: 0 auto;
}

.placeholder .heading {
    @apply text-center w-40 h-8 flex flex-col items-center;
    margin: 0 auto;
    margin-top: 20px !important;
    margin-bottom: 30px !important;
}

// .placeholder,
.placeholder .preview,
.placeholder .heading,
.placeholder:after,
.placeholder:before {
    /* bg-gray-300 */
    background-color: #e3e7ed;
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: shimmer;
    animation-timing-function: linear;
    background-size: 800px 10px;
    background-image: linear-gradient(90deg,#e3e7ed 8%,#cdd4e0 18%,#e3e7ed 33%);
}
</style>
